import { useRef as n } from "react";
function c(e, t) {
  const r = n();
  return r.current && t() || (r.current = e()), r.current;
}
export {
  c as useMemoCallback
};
//# sourceMappingURL=index5.js.map
